var data = {
  "body": "<path d=\"M289.94 256l95-95A24 24 0 0 0 351 127l-95 95l-95-95a24 24 0 0 0-34 34l95 95l-95 95a24 24 0 1 0 34 34l95-95l95 95a24 24 0 0 0 34-34z\" fill=\"currentColor\"/>",
  "width": 512,
  "height": 512
};
exports.__esModule = true;
exports.default = data;